import type { FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export interface LeaveWithoutSavingDialogProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

const LeaveWithoutSavingDialog: FC<LeaveWithoutSavingDialogProps> = ({
  open,
  onStay,
  onLeave,
}) => (
  <Dialog
    fullWidth
    maxWidth="xs"
    open={open}
    onClose={(event, reason) => {
      if (reason !== 'backdropClick') {
        onStay();
      }
    }}
  >
    <DialogTitle>Leave editing without saving?</DialogTitle>
    <DialogContent>
      <Typography variant="body1">Changes will be lost</Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
      <Button onClick={onStay} variant="text" color="primary">
        Continue editing
      </Button>
      <Button onClick={onLeave} variant="contained" color="error">
        Leave without saving
      </Button>
    </DialogActions>
  </Dialog>
);

export default LeaveWithoutSavingDialog;
